/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown>, currency: NonNullable<unknown> }} Membership_Option_Add_DescriptionInputs */

const fr_membership_option_add_description = /** @type {(inputs: Membership_Option_Add_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} ${i?.currency} / mois supplémentaires, facturés au prorata dès maintenant.`)
};

/**

* @param {Membership_Option_Add_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_option_add_description = /** @type {((inputs: Membership_Option_Add_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Option_Add_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_option_add_description(inputs)
});